import './NotificationDeleteModal.scss';

import React, { useState } from 'react';
import { ActionMenuType, NotificationData, NotificationsDispatch } from '../notifications-types';
import GfModal from '../../gfcomponents/GfModal/GfModal';
import { markForDelete, setDeleteModalOpen } from '../actions';
import { CheckboxProps } from 'semantic-ui-react';
import { useUserPersistedState } from '../../persistedstate/users/useUserPersistedState';

export type NotificationDeleteModalProps = {
  deleteModalOpen: boolean;
  notificationDataList: NotificationData[];
  actionMenuType?: ActionMenuType;
  dispatch: NotificationsDispatch;
};

export default function NotificationDeleteModal(props: NotificationDeleteModalProps) {
  const { deleteModalOpen, notificationDataList, actionMenuType, dispatch } = props;
  const [checked, setChecked] = useState(false);
  const [dismissedDeleteNotificationPrompt, setDismissedDeleteNotificationModal] = useUserPersistedState('dismissDeleteNotificationPrompt');

  const isSingleNotification = notificationDataList?.length === 1;
  const showCheckbox = !dismissedDeleteNotificationPrompt && actionMenuType?.name !== 'Bulk';

  const getModalTitle = () => {
    return isSingleNotification ? "You're about to clear this notification" : "You're about to clear your read notifications";
  };

  const getModalContent = () => {
    return isSingleNotification ? (
      <p>Cleared notifications cannot be recovered. Are you sure you want to clear this notification?</p>
    ) : (
      <>
        <p>Once you clear your notifications, they cannot be recovered.</p>
        <br />
        <p>Are you sure you want to continue?</p>
      </>
    );
  };

  const getPrimaryButtonText = () => {
    return isSingleNotification ? 'Yes, clear notification' : 'Yes, clear notifications';
  };

  const handlePrimaryClick = () => {
    setDismissedDeleteNotificationModal(checked);
    markForDelete(notificationDataList, dispatch);
  };

  const handleNoShowCheckboxChange = (data: CheckboxProps) => {
    setChecked(data.checked);
  };

  return (
    <GfModal
      className="notification-delete-modal"
      open={deleteModalOpen}
      onClose={() => dispatch(setDeleteModalOpen(false))}
      title={getModalTitle()}
      primaryText={getPrimaryButtonText()}
      onPrimaryClick={handlePrimaryClick}
      tertiaryText="No, go back"
      onTertiaryClick={() => dispatch(setDeleteModalOpen(false))}
      actionButtonProps={
        showCheckbox && {
          checkbox: { label: 'Do not show this message again', checked: checked, onChange: (_, data) => handleNoShowCheckboxChange(data) }
        }
      }
    >
      <div className="delete-modal-content">{getModalContent()}</div>
    </GfModal>
  );
}
